import { output, signal, viewChild } from '@angular/core';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["autocompleter"];
const _forTrack0 = ($index, $item) => $item.securityId;
function AgentSmartCompareModalComponent_For_10_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 11);
    i0.ɵɵlistener("click", function AgentSmartCompareModalComponent_For_10_Template_div_click_3_listener() { const ɵ$index_16_r3 = i0.ɵɵrestoreView(_r2).$index; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.removeItem(ɵ$index_16_r3)); });
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 12);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipPlacement", "left")("tooltipTitle", item_r5.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r5.displaySecurityId, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-close-circle");
} }
export class AgentSmartCompareModalComponent {
    constructor() {
        this.submitCompare = output();
        this.dismiss = output();
        this._autocompleter = viewChild('autocompleter', ...(ngDevMode ? [{ debugName: "_autocompleter" }] : []));
        this.isOpen = signal(false, ...(ngDevMode ? [{ debugName: "isOpen" }] : []));
        this.items = signal([], ...(ngDevMode ? [{ debugName: "items" }] : []));
        this.minItems = 2;
        this.maxItems = 12;
    }
    open(prefilled = []) {
        this.items.set(prefilled.slice(0, this.maxItems));
        this.isOpen.set(true);
        setTimeout(() => this._autocompleter()?.focus(), 0);
    }
    close() {
        this.isOpen.set(false);
        this.items.set([]);
    }
    onAutocompleteSelect(result) {
        const current = this.items();
        if (current.length >= this.maxItems) {
            return;
        }
        if (current.some((i) => i.securityId === result.search_id)) {
            return;
        }
        this.items.set([
            ...current,
            {
                securityId: result.search_id,
                displaySecurityId: result.display_security_id,
                name: result.name,
            },
        ]);
    }
    removeItem(index) {
        const next = [...this.items()];
        next.splice(index, 1);
        this.items.set(next);
    }
    canSubmit() {
        const { length } = this.items();
        return length >= this.minItems && length <= this.maxItems;
    }
    submit() {
        if (!this.canSubmit()) {
            return;
        }
        const items = this.items();
        const securityIds = items.map((i) => i.securityId);
        const displayIds = items.map((i) => i.displaySecurityId);
        const promptText = displayIds.length === 2
            ? `Smart Compare ${displayIds[0]} and ${displayIds[1]}`
            : `Smart Compare ${displayIds.slice(0, -1).join(', ')} and ${displayIds[displayIds.length - 1]}`;
        this.submitCompare.emit({ securityIds, promptText });
        this.close();
    }
    onDismiss() {
        this.close();
        this.dismiss.emit();
    }
}
AgentSmartCompareModalComponent.ɵfac = function AgentSmartCompareModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentSmartCompareModalComponent)(); };
AgentSmartCompareModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentSmartCompareModalComponent, selectors: [["ycn-agent-smart-compare-modal"]], viewQuery: function AgentSmartCompareModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx._autocompleter, _c0, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance();
    } }, outputs: { submitCompare: "submitCompare", dismiss: "dismiss" }, decls: 12, vars: 9, consts: [["autocompleter", ""], [3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [3, "submitHandler", "searchType", "placeholder", "appendToBody"], [1, "text-muted", "mt-1"], [1, "d-flex", "flex-wrap", "mt-2"], [1, "btn", "btn-purple-tint", "mr-1", "mb-1"], [3, "cancelHandler", "submitHandler", "disableSubmission", "submitButtonText"], ["ycnTooltip", "", 3, "tooltipPlacement", "tooltipTitle"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["ycnIcon", "", 3, "name"]], template: function AgentSmartCompareModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function AgentSmartCompareModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onDismiss()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function AgentSmartCompareModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onDismiss()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "ycn-icon-search-autocomplete", 5, 0);
        i0.ɵɵlistener("submitHandler", function AgentSmartCompareModalComponent_Template_ycn_icon_search_autocomplete_submitHandler_4_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onAutocompleteSelect($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵrepeaterCreate(9, AgentSmartCompareModalComponent_For_10_Template, 6, 4, "div", 8, _forTrack0);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(11, "ycn-simple-modal-footer", 9);
        i0.ɵɵlistener("cancelHandler", function AgentSmartCompareModalComponent_Template_ycn_simple_modal_footer_cancelHandler_11_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onDismiss()); })("submitHandler", function AgentSmartCompareModalComponent_Template_ycn_simple_modal_footer_submitHandler_11_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submit()); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen());
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Smart Compare");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("searchType", "quickflow_securities")("placeholder", "Add a security")("appendToBody", true);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate2("Compare ", ctx.minItems, " to ", ctx.maxItems, " securities.");
        i0.ɵɵadvance(2);
        i0.ɵɵrepeater(ctx.items());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disableSubmission", !ctx.canSubmit())("submitButtonText", "Compare");
    } }, dependencies: [IconSearchAutocompleteModule, i1.IconSearchAutocompleteComponent, ModalBaseModule, i2.ModalBaseComponent, i3.SimpleModalFooterComponent, i4.SimpleModalHeaderComponent, IconModule, i5.IconDirective, TooltipModule, i6.TooltipDirective], encapsulation: 2, changeDetection: 0 });
